import { Box, LinearProgress } from "@mui/material";

interface Props {
  showLoading: boolean;
}
export function LoadingBarHorizontal({ showLoading }: Props) {
  return (
    <Box sx={{ width: '100%', height: 2 }}>
      {showLoading ? <LinearProgress /> : null}
    </Box>
  )
}
